// api/my-access.ts — the signed-in customer's own VPN access. The portal
// backend scopes every response to the session identity; the SPA never supplies
// an email. "Request renewal" nudges the group's approver(s) — it does not renew
// (renewal is approver-only, decision #39).

import { api } from './client';
import type { MyAccessResponse } from './types';
export { grantErrorMessage } from './approver';

const BASE = '/api/me/access';

export function listMyAccess(): Promise<MyAccessResponse> {
    return api<MyAccessResponse>(BASE);
}

export interface RenewalRequestResult {
    requested: boolean;
    alreadyRequested?: boolean;
    renewalRequestedAt?: string;
}

export function requestRenewal(grantId: string): Promise<RenewalRequestResult> {
    return api<RenewalRequestResult>(`${BASE}/${encodeURIComponent(grantId)}/request-renewal`, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({}),
    });
}
